import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SnackbarService } from "@fuse/services/snackbar";
import { TranslocoService } from "@jsverse/transloco";
import { map } from "rxjs";
import { PermissionService } from "./permission.service";

export function permissionGuard(code: string): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);
    const snackbarService = inject(SnackbarService);
    const translocoService = inject(TranslocoService);

    // Guards rodam antes dos resolvers do layout: carrega aqui mesmo (load é deduplicado).
    return permissionService.load().pipe(
      map(() => {
        if (permissionService.has(code)) {
          return true;
        }

        snackbarService.open(translocoService.translate("messages.no_permission"), "error");

        return router.createUrlTree(["/"]);
      }),
    );
  };
}
